import MicroModal from 'micromodal';

$(function () {
    if ($('.mypage.index').length > 0) {
        // 本人確認依頼OKクリック
        $(document).on(oEventNames.end, '#modal-confirm .btn-ok', function (event) {
            if (!bIsScrolling) {
                event.preventDefault();
                window.location.href = '/mypage/request-identification';
            }
        });
    }
});

if ($('#js-copy').length) {
    // コピーボタン
    const btn_copy = document.querySelector('#js-copy');
    // コピー対象となるテキスト
    const copy_target = document.querySelector('#target');

    // コピーボタンのクリックイベント
    btn_copy.addEventListener('click', () => {
        copyText(copy_target);
    });

    const copyText = (target) => {
        // テキストの選択
        document.getSelection().selectAllChildren(target);
        // 選択範囲のコピー
        document.execCommand('copy');
        // テキスト選択の解除
        document.getSelection().empty(target);
    };
    $(function () {
        $('#js-copy').click(function () {
            $(this).addClass('copied'); //ボタンの色などを変更するためにクラスを追加
            $(this).text('コピーしました'); //テキストの書き換え
        });
    });
}
$(function () {
    // 就職活動の状況
    function jobStatusText() {
        const jobStatus = $('#modal-job-status input[name="job_status"]:checked').val();
        if ($('#modal-job-status input[type="radio"][name="job_status"]:checked').is(':checked')) {
            $('#modal-job-status .js-job-status-submit').removeAttr('disabled');
        } else {
            $('#modal-job-status .js-job-status-submit').attr('disabled', 'disabled');
        }
        if (jobStatus == 4) {
            // 就職活動終了を選択した場合
            $('#modal-job-status .js-job-status-text').fadeIn();
        } else {
            // それ以外の場合
            $('#modal-job-status .js-job-status-text').fadeOut();
        }
    }
    $('#modal-job-status input[name="job_status"]').on('change', function () {
        jobStatusText();
    });
    // 編集ボタン
    $('.open-modal-job-status').on(oEventNames.end, function (event) {
        if (!bIsScrolling) {
            event.preventDefault();
            jobStatusText();
            MicroModal.show('modal-job-status', {
                awaitCloseAnimation: true,
                disableScroll: true,
            });
        }
    });
    // 更新するボタンを押したら
    $(document).on(oEventNames.end, '#modal-job-status .js-job-status-submit', function (event) {
        if (!bIsScrolling) {
            event.preventDefault();
            // postするデータ
            const postData = {
                jobStatus: $('input[name="job_status"]:checked').val(),
            };

            $.ajax({
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                url: '/ajax/users/job-status',
                type: 'POST',
                dataType: 'json',
                data: postData,
            })
                // Ajaxリクエストが成功した時発動
                .done((data) => {
                    // 就職活動の状況の表示を更新
                    $('#job-status-text').text(data.jobStatusText);
                    // メッセージ・受信設定の表示を更新
                    if (data.messageOffer) {
                        $('#message-offer-checkbox').addClass('check');
                    } else {
                        $('#message-offer-checkbox').removeClass('check');
                    }
                    MicroModal.close('modal-job-status');
                    $.toast({
                        heading: '就職活動の状況を保存しました。',
                        text: '',
                        showHideTransition: 'slide',
                        icon: 'success',
                        position: 'bottom-right',
                        hideAfter: 6000,
                    });
                })
                // Ajaxリクエストが失敗した時発動
                .fail((data) => {
                    $.toast({
                        heading: '就職活動の状況の保存に失敗しました。',
                        text: 'お手数ですが、再度お試しいただき、それでも失敗する場合はお問い合わせくださいませ。',
                        showHideTransition: 'slide',
                        icon: 'error',
                        position: 'bottom-right',
                        hideAfter: 6000,
                    });
                })
                // Ajaxリクエストが成功・失敗どちらでも発動
                .always((data) => {});
        }
    });
});
